<template>
  <div class="primary__color__bg">
    <div class="home-container text-center speaker-home">
      <div class="title-speaker primary__color__text">
        {{ $t("speakers.main") }}
      </div>
      <el-skeleton animated>
        <template #template>
          <el-skeleton-item variant="circle" />
        </template>
      </el-skeleton>
      <br />
      <el-skeleton :rows="1" animated />
    </div>
  </div>
</template>
<style>
.speaker-home > div > .el-skeleton__circle {
  width: 80px;
  height: 80px;
}
</style>
<style scoped>
.title-speaker {
  font-size: 2rem;
  font-weight: 700;
  padding: 1rem 0 0 0;
  text-align: center;
  margin-bottom: 15px;
}
</style>
